export default "__VITE_ASSET__fbdd8278__"